import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  isOpen: true,
};

const ticketDetailSidebarSlice = createSlice({
  name: 'ticketDetailSidebar',
  initialState,
  reducers: {
    openTicketDetailSidebar: (state) => {
      state.isOpen = true;
    },
    closeTicketDetailSidebar: (state) => {
      state.isOpen = false;
    },
    toggleTicketDetailSidebar: (state) => {
      state.isOpen = !state.isOpen;
    },
  },
});

export const {
  openTicketDetailSidebar,
  closeTicketDetailSidebar,
  toggleTicketDetailSidebar,
} = ticketDetailSidebarSlice.actions;

export const selectIsTicketDetailSidebarOpen = (state) => state.ticketDetailSidebar.isOpen;

export default ticketDetailSidebarSlice.reducer; 